import React from 'react'
import SectionContainer from '../../../../../Homepage/SectionContainer'
import BreadCrumb from '../../../../../component/BreadCrumb/BreadCrumb'
import plss1 from "../../../../svg/logo1.svg"
import plss2 from "../../../../svg/plss2.svg"
import logo1 from "../../../../svg/primaryLogo.svg"
import logo2 from "../../../../svg/logo2.svg"
import pls1 from "../../../../svg/pls1.svg"
import pls2 from "../../../../svg/pls2.svg"
import pc1 from "../../../../svg/pc1.svg"
import pc2 from "../../../../svg/pc2.svg"
import bg1 from "../../../../svg/bg1.svg"
import pt1 from "../../../../svg/pt1.svg"
import pt2 from "../../../../svg/pt2.svg"
import "./brand.css"
import { Link } from 'react-router-dom'

const Brand = () => {
    const text = `The Kangaroo Education Foundation’s primary logo consists of two key elements: the “Brandmark” and the “Wordmark.” In this V: 2.0 Brand Identity Guidelines, the primary logo has been subtly updated to better align with our evolving brand identity. It is prominently used across all Corporate Communication Materials and Corporate Materials, as detailed in the later sections of these guidelines.`
    const text2 = `The Kangaroo Education Foundation’s secondary logo features only the “Wordmark” and has been introduced in this V: 2.0 Brand Identity Guidelines. This secondary logo was designed to enhance the brand’s visual prominence across various materials. It is primarily used in Brand Communication Materials and Sales Communication Materials, ensuring the brand remains visually impactful and recognizable in every context.`
    return (
        <SectionContainer>
            <BreadCrumb items={[
                { title: "HOME", link: "/" },
                { title: "BRAND IDENTITY GUIDELINE", link: "/brand-identity-guideline" },
                { title: "BRAND" },
            ]} instituition={false} className="" />

            <h1 className="font-level-1" style={{ marginBottom: "6rem" }}>BRAND.</h1>

            <hr className="line" />
            <h1 className="font-level-2" ><span className="text-muted">BRAND.</span>LOGO</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            <h1 className="country-paragraph-text">Primary Logo</h1>
            <img src={logo1} style={{ width: "30%" }} alt="" />
            <p className="country-paragraph-text" style={{ whiteSpace: "pre-line", marginTop: "5rem" }}>{text}</p>
            <Link to={"/artwork"}>
                <button className="px-4 py-2 country-paragraph-text" style={{ backgroundColor: "white", color: "#812990", borderRadius: "5px", border: "1px solid #812990" }}>Download Primary Logo</button>
            </Link>
            <hr className="line" style={{ marginBottom: "7.5rem", marginTop: "5rem" }} />
            <h1 className="country-paragraph-text">Secondary Logo</h1>
            <img src={logo2} style={{ width: "30%" }} alt="" />
            <p className="country-paragraph-text" style={{ whiteSpace: "pre-line", marginTop: "5rem" }}>{text2}</p>
            <Link to={"/artwork"}>
                <button className="px-4 py-2 country-paragraph-text" style={{ backgroundColor: "white", color: "#812990", borderRadius: "5px", border: "1px solid #812990" }}>Download Secondary Logo</button>
            </Link>
            <hr className="line" style={{ marginBottom: "7.5rem", marginTop: "5rem" }} />
            <h1 className="country-paragraph-text">Primary Logo Structure</h1>
            <img src={pls1} className="w-50" alt="" />
            <hr className="line" style={{ marginBottom: "5rem", marginTop: "5rem" }} />
            <h1 className="country-paragraph-text">Secondary Logo Structure</h1>
            <img src={pls2} className="w-50" alt="" />
            <hr className="line" style={{ marginBottom: "5rem", marginTop: "5rem" }} />
            <h1 className="country-paragraph-text">Primary Logo Incorrect Usage</h1>
            <img src={plss1} alt="" />
            <p className="country-paragraph-text" style={{ whiteSpace: "pre-line", marginTop: "5rem", marginBottom: "5rem" }}>The examples shown above depict incorrect usage of the Primary Logo. Altering its shape, size, color, or any other aspect is strictly prohibited and must not be accepted in any material produced.</p>
            <hr className="line" style={{ marginBottom: "5rem", }} />
            <h1 className="country-paragraph-text">Secondary Logo Incorrect Usage</h1>
            <img src={plss2} alt="" />
            <p className="country-paragraph-text" style={{ whiteSpace: "pre-line", marginTop: "5rem", marginBottom: "10rem" }}>The examples shown above depict incorrect usage of the Secondary Logo. Altering its shape, size, color, or any other aspect is strictly prohibited and must not be accepted in any material produced.</p>
            <hr className="line" />
            <h1 className="font-level-2"><span className="text-muted">BRAND.</span>COLOR</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            <h1 className="country-paragraph-text">Primary Color</h1>
            <img src={pc1} alt="" />
            <hr className="line" style={{ marginBottom: "5rem", marginTop: "5rem" }} />
            <h1 className='country-paragraph-text'>Secondary Color</h1>
            <img src={pc2} alt="" />
            <hr className="line" style={{ marginBottom: "5rem", marginTop: "5rem" }} />
            <h1 className='country-paragraph-text'>Background Color</h1>
            <img src={bg1} alt="" style={{ marginBottom: "10rem" }} />
            <hr className="line" />
            <h1 className="font-level-2"><span className="text-muted">BRAND.</span>TYPEFACE</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            <h1 className='country-paragraph-text'>Primary Typeface</h1>
            <img src={pt1} alt="" />
            <hr className="line" style={{ marginBottom: "5rem", marginTop: "5rem" }} />
            <h1 className='country-paragraph-text'>Secondary Typeface</h1>
            <img src={pt2} alt="" />
            <p className="country-paragraph-text" style={{ whiteSpace: "pre-line", marginTop: "5rem", marginBottom: "10rem" }}>In addition to the Primary Typeface, there are 2 English and 4 Nepali typefaces designated as Secondary Typefaces. These can be used in special cases when required.</p>



        </SectionContainer>
    )
}

export default Brand